module.exports = require("debug");


//////////////////
// WEBPACK FOOTER
// external "debug"
// module id = 12
// module chunks = 0